import sha256 from 'crypto-js/sha256'
import { useEffect } from 'react'

import { VITE_FB_PIXEL_IDS } from '../constants/config'
import { useBoundStore } from '../store/store'
import { getAdsInfo } from '../utils/ads-info'

function useFbPixel() {
  const email = useBoundStore(state => state.user.email)
  const phone = useBoundStore(state => state.user.phone)
  const userId = useBoundStore(state => state.user.userID)
  const isUserLoading = useBoundStore(state => state.user.isLoading)
  const userIP = useBoundStore(state => state.settings.userIP)

  useEffect(() => {
    if (isUserLoading || !VITE_FB_PIXEL_IDS || !fbq) return
    const adsInfo = getAdsInfo()
    VITE_FB_PIXEL_IDS.split(',').forEach(id => {
      fbq?.('init', id.trim(), {
        ...(email && { em: [sha256(email).toString()] }),
        ...(phone && { ph: [sha256(phone).toString()] }),
        client_user_agent: navigator.userAgent,
        client_ip_address: userIP,
        ...(userId && { external_id: [sha256(userId).toString()] }),
        ...(adsInfo.fbclid && { fbc: adsInfo.fbclid }),
        ...(adsInfo.fbp && { fbp: adsInfo.fbp }),
      })
    })
  }, [isUserLoading, email, phone, userId, userIP])
}

export default useFbPixel
